import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

export const AppContext = React.createContext({
  showMessage: () => {},
  hideMessage: () => {},
});

export default function AppProvider({ children }) {
  const [message, setMessage] = React.useState({
    visible: false,
    severity: "",
    message: "",
  });

  const showMessage = (message, severity) => {
    setMessage({
      visible: true,
      severity: severity,
      message: message,
    });
  };

  const hideMessage = () => {
    setMessage({
      visible: false,
      severity: "",
      message: "",
    });
  };

  const providedContext = {
    showMessage,
    hideMessage,
  };

  return (
    <AppContext.Provider value={providedContext}>
      <Snackbar
        open={message.visible}
        autoHideDuration={3000}
        onClose={hideMessage}
      >
        <MuiAlert elevation={6} variant="filled" severity={message.severity}>
          {message.message}
        </MuiAlert>
      </Snackbar>
      {children}
    </AppContext.Provider>
  );
}
